import {connect} from 'react-redux';

import {InboxModel} from '../../../../libs/shared/core/src/models/api/inboxModel';
import {WorkspaceDisplayActionsEnum} from '../../../../libs/shared/core/src/models/tracking/contexts/workspaceTracking';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../libs/shared/core/src/services/tracking/tracking';
import {makeMapDispatchToProps, makeMapStateToProps} from '../../../../srcCommon/helpers/reselectHelpers';
import {
  SettingsInboxesResourcePagesEnum,
  SettingsInboxesTabPagesEnum,
  SettingsSingleInboxSubPagesEnum,
} from '../../../models/url/models/settingsInboxesUrlModel';
import {SettingsRootPagesEnum} from '../../../models/url/models/types';
import {buildSettingsPath} from '../../../models/url/settingsUrlHelpers';
import {ThunkAction} from '../../../store/appThunk';
import {makeGetCounterIsUnread} from '../../../store/data/preferences/countersSelectors';
import {hideWorkspaceInboxAsyncAction} from '../../../store/data/workspace/workspaceActions';
import {startedEditingWorkspacesAction} from '../../../store/panels/inboxes/inboxesPanelActions';
import {navigateToLinkAction} from '../../../store/stateless/navigationActions';
import {WorkspaceInboxItemContainerComponent} from './workspaceInboxItemContainerComponent';
import {
  createCommonWorkspaceItemSelectors,
  WorkspaceItemContainerProps,
} from './workspaceItemContainerHelpers';

interface WorkspaceInboxItemContainerBaseProps extends Omit<WorkspaceItemContainerProps, 'inbox'> {
  inbox: InboxModel;
}

// Omits 'inbox' from WorkspaceItemContainerProps as it already exists in WorkspaceInboxItemContainerProps
const inboxMapStateToProps = makeMapStateToProps<Omit<WorkspaceItemContainerProps, 'inbox'>>()(() => {
  const commonSelectors = createCommonWorkspaceItemSelectors();
  return {
    ...commonSelectors,
    isUnread: makeGetCounterIsUnread(commonSelectors.badgeValue),
  };
});

const mapDispatchToProps = makeMapDispatchToProps<WorkspaceInboxItemContainerBaseProps>()(
  ({panelId, trackingSection, inbox}) => ({
    editWorkspaces: (hasRarelyViewedItems: boolean) => {
      trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_CLICK, {
        action: WorkspaceDisplayActionsEnum.VIEW_SIDEBAR,
        section: trackingSection,
      });
      return startedEditingWorkspacesAction(panelId, hasRarelyViewedItems);
    },
    onHideFromWorkspace:
      (inboxId: number): ThunkAction =>
      (dispatch) => {
        dispatch(hideWorkspaceInboxAsyncAction(inboxId, inbox.namespace));
      },
    onEditClick: () =>
      navigateToLinkAction(
        buildSettingsPath({
          rootPage: SettingsRootPagesEnum.INBOXES,
          inboxId: inbox.id,
          namespace: inbox.namespace,
          resourcePage: SettingsInboxesResourcePagesEnum.EDIT,
          subPage: SettingsSingleInboxSubPagesEnum.OVERVIEW,
          tabPage: SettingsInboxesTabPagesEnum.INBOXES,
        }),
      ),
  }),
);

export const WorkspaceInboxItemContainerBase = connect(
  inboxMapStateToProps,
  mapDispatchToProps,
  (stateProps, dispatchProps, ownProps) => {
    const {editWorkspaces, onHideFromWorkspace, onEditClick} = dispatchProps;
    const onEditWorkspaces = () => {
      editWorkspaces(stateProps.hasRarelyViewedItems);
    };
    return {
      ...stateProps,
      ...ownProps,
      onEditWorkspaces,
      onHideFromWorkspace,
      onEditClick,
    };
  },
)(WorkspaceInboxItemContainerComponent);
